var React = require('react');
var {
    Input,
    Button,
    Link,
    Text,
    ActionButton,
    List,
    ListItem,
    Layout,
    Modal,
    ModalContent,
    Heading,
    Text,
    Spinner
} = require('@metro-ui/core');
var { Trash } = require('@metro-ui/icons/');
var LoginStore = require('../../stores/LoginStore.js');
var LoginActions = require('../../actions/LoginActions.js');
var _ = require('lodash');

var ReactIntl = require('react-intl');
var injectIntl = ReactIntl.injectIntl;
var LoginPreferencesCardWrapper = require('./LoginPreferencesCardWrapper');
var defaultMessages = require('../../i18n/messages/default');
var base64url = require('base64url');

class TwoFaViaFingerprintPopUp extends React.Component {
    constructor(props) {
        super(props);
        const browserSupportWebauthn = (typeof(PublicKeyCredential) != "undefined") ? true : false;
        this.state = {
            code: '',
            addNewKeyForm:false,
            showConfirmation: false,
            deviceName: '',
            webauthnSupported : browserSupportWebauthn
        };
        this.save2faWebAuthnListener = this.save2faWebAuthnListener.bind(this);
        this.onUserCredentialsCreated = this.onUserCredentialsCreated.bind(this);
        this.onWebauthnCredentials = this.onWebauthnCredentials.bind(this);
        this.onCredentialDelete.bind(this);
        this.onCredentialDeleteConfirm.bind(this);
        this.onCredentialDeleteCancel.bind(this);
        this.deleteCredentialFromAuthzListener = this.deleteCredentialFromAuthzListener.bind(this);
        this._onBackNavigationClick = this.onBackNavigationClick.bind(this);
    }

    componentDidMount() {
        LoginStore.Save2FAWebAuthnListener(this.save2faWebAuthnListener);
        LoginStore.userCredentialsCreatedListener(this.onUserCredentialsCreated);
        LoginStore.webauthnCredentialsListener(this.onWebauthnCredentials);
        LoginStore.webauthnCredentialsDeletedListener(this.deleteCredentialFromAuthzListener);
        LoginActions.get2faWebAuthnCredentials(this.props.idToken,this.props.decodedIdToken.sub,this.props.traceId);
    }

    componentWillUnmount() {
        LoginStore.removeSave2FAWebAuthnListener(this.save2faWebAuthnListener);
        LoginStore.removeUserCredentialsCreatedListener(this.onUserCredentialsCreated);
        LoginStore.removeWebauthnCredentialsListener(this.onWebauthnCredentials);
        LoginStore.removeWebauthnCredentialsDeletedListener(this.deleteCredentialFromAuthzListener);
    }

    onWebauthnCredentials() {
        let appState = LoginStore.getState();
        if(appState.fetchWebauthnFailure){
            LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.get_keys_failure_msg']), "error", true);
            this.setState({ userWebauthnDevices: [] });
        }else{
            this.setState({ userWebauthnDevices: appState.userWebauthnDevices });
        }
    }

    save2faWebAuthnListener() {

        let appState = LoginStore.getState();
        if(appState.updateAuthnMethodError){
            LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.msg_setup_failed']), "error", true);
        }else{
            LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.msg_setup_successful']), "success", true);

            this.props.onNavItemClick(2, true); //pass true to GetUserDetails
        }

    }

    onUserCredentialsCreated(){
        let appState = LoginStore.getState();
        let userCredentialsCreated =  appState.userCredentialsCreated;
        console.log("Webauthn Cred : ");
        console.log(JSON.stringify(userCredentialsCreated));
        LoginStore.save2faCred(this.props.idToken,
            userCredentialsCreated,this.props.decodedIdToken.sub,this.state.deviceName,this.props.userType, this.props.traceId);
    }

    addNewKey(evt){
        this.setState({ addNewKeyForm: true });
    }
    showExistingKeys(evt){
        this.setState({ deviceName: '' });
        this.setState({ addNewKeyForm: false });
    }

    createCredentials(evt){  
        let appState = LoginStore.getState();
        let challenge =  appState.challenge;
        console.log("challenge receievd in passed in registration call: "+challenge );
        LoginActions.createWebauthnCredentials(this.props.idToken, challenge, this.props.decodedIdToken.sub, this.props.email, this.props.traceId )
    }

    storeDeviceName(ev, value) {
        this.setState({ deviceName: value });
    }

    onCredentialDelete(deviceName,credId){
        console.log("Delete Device.  "+deviceName+":"+credId);
        // var newList = this.state.userWebauthnDevices.filter(eachDevice=>{return(!(eachDevice.deviceName === deviceName && eachDevice.credId === credId))});
        this.setState({ showConfirmation: true });
        this.setState({ deviceName: deviceName });
        this.setState({ credId: credId });
    }
    onCredentialDeleteConfirm(){
        console.log("Delete Device confirmation.  "+this.state.deviceName+":"+this.state.credId);
        var newList = this.state.userWebauthnDevices.filter(eachDevice=>{return(!(eachDevice.deviceName === this.state.deviceName && eachDevice.credId === this.state.credId))});
        this.setState({ userWebauthnDevices: newList });
        console.log("newList :"+newList);
        this.setState({ showConfirmation: false });
        LoginActions.deleteWebauthnCredentials(this.props.idToken,this.state.deviceName,this.state.credId,this.props.decodedIdToken.sub,this.state.traceId)
    }
    onCredentialDeleteCancel(){
        this.setState({ showConfirmation: false });
    }

    deleteCredentialFromAuthzListener(){
        this.setState({ deviceName: '' });
        LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.key_delete_successful']), "success", true);
        LoginActions.get2faWebAuthnCredentials(this.props.idToken,this.props.decodedIdToken.sub,this.state.traceId);
    }

    onBackNavigationClick() {
        if (this.state.addNewKeyForm)
            this.setState({ addNewKeyForm: false });
        else
            this.props.onNavItemClick(2);
    }

    render() {
        const deviceNamePlaceholder = this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.device_name_hint']);
      
        return (
            <LoginPreferencesCardWrapper headingText={this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.setup'])}
                onBackNavigationClick={this._onBackNavigationClick} showBackNavIcon={true}>
                { !this.state.addNewKeyForm &&
                    <div>
                        <div className= "margin-bottom-small" style={{border: 'solid 1px #e6e6e6', padding:'1rem'}}>
                            <List
                                label={this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.label.your_existing_keys'])}
                                padding="large"
                                hasDivider
                                hasHover
                            >
                                { this.state.userWebauthnDevices ? ( this.state.userWebauthnDevices.length === 0 ?
                                    <ListItem>
                                        <Layout
                                            align="baseline"
                                            spacing="x-large"
                                            style={{width: '100%'}}
                                        >
                                            <Layout grow={1}>
                                                <div>
                                                    {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.no_device_configured_yet'])}
                                                </div>
                                            </Layout>
                                        </Layout>
                                    </ListItem> : this.state.userWebauthnDevices.map(eachDevice=>{
                                        return(
                                            <ListItem>
                                                <Layout
                                                    align="baseline"
                                                    spacing="x-large"
                                                    style={{width: '100%'}}
                                                >
                                                    <Layout grow={1}>
                                                        <div>
                                                            {eachDevice.deviceName}
                                                        </div>
                                                    </Layout>
                                                    <ActionButton
                                                        Icon={Trash}
                                                        label="ActionButton"
                                                        onClick={(e)=>this.onCredentialDelete(eachDevice.deviceName,eachDevice.credId)}
                                                        size="small"
                                                        variant="primaryWarning"
                                                    >
                                                        primary
                                        </ActionButton>
                                                </Layout>
                                            </ListItem>);
                                    })
                                ):
                                    <ListItem>
                                        <Layout
                                            align="baseline"
                                            spacing="x-large"
                                            style={{width: '100%'}}
                                        >
                                            <Layout grow={1}>
                                                <Spinner label="Loading content" />
                                            </Layout>

                                        </Layout>
                                    </ListItem>
                                }


                            </List>
                        </div>
                        {!this.state.webauthnSupported && <Text className= "margin-bottom-small" size= "small" color="warning">
                            *{this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.browswer_not_supported'])}
                        </Text>}
                        <Button isWide
                            size= 'medium'
                            className= "form-controls"
                            isFullWidth= {false}
                            variant='primary'
                            isDisabled={!this.state.webauthnSupported}
                            onClick={this.addNewKey.bind(this)}>
                            {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.add_new_key'])}
                        </Button>

                    </div>

                }
                {this.state.addNewKeyForm && <div>
                    <Text className="margin-bottom-small" size="medium">
                        <strong>{this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.step_0'])}</strong>
                    </Text>
                    <Text className="margin-bottom-small" size="medium">
                        {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.step_1'])}</Text>
                    <Input className="form-controls"
                        placeholder={deviceNamePlaceholder}
                        value={this.state.deviceName}
                        onChange={this.storeDeviceName.bind(this)}
                        isRequired={true} />
                    {this.state.userWebauthnDevices.filter(eachDevice => { return eachDevice.deviceName.toUpperCase() === this.state.deviceName.trim().toUpperCase(); }).length != 0 &&
                        <Text className="margin-bottom-small" size="small" color="warning">
                            {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.device_name_already_exist'])}
                        </Text>}
                    <Text className="margin-bottom-small" size="medium">
                        {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.step_2'])}</Text>
                    <Text className="margin-bottom-small" size="medium">
                        {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.step_3'])}</Text>
                    <div>
                        <Button isWide
                            size='medium'
                            className="form-controls"
                            isFullWidth={false}
                            variant='primary'
                            isDisabled={this.state.deviceName.trim().length === 0 || this.state.userWebauthnDevices.filter(eachDevice => { return eachDevice.deviceName.toUpperCase() === this.state.deviceName.trim().toUpperCase(); }).length != 0}
                            onClick={this.createCredentials.bind(this)}>
                            {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.register_device'])}
                        </Button>
                    </div>
                </div>}
                {this.state.showConfirmation == true &&
                    <Modal
                        aria-labelledby="modal-title"
                        isOpen
                    >
                        <ModalContent
                            direction="column"
                            padding="xx-large"
                            spacing="medium"
                        >
                            <Heading
                                align="center"
                                color="primary"
                                hasNoNativeMargin
                                id="modal-title"
                            >
                                {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.confirmation'])}?
                            </Heading>
                            <Text
                                align="center"
                                hasNoNativeMargin
                            >
                                {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.delete_message_first_part'])} <strong>{this.state.deviceName}</strong>.
                                <br />
                                {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.delete_message_second_part'])}
                            </Text>
                            <Layout
                                grow={0}
                                justify="center"
                            >
                                <Button variant="primaryWarning"
                                    onClick={this.onCredentialDeleteConfirm.bind(this)}
                                >
                                    {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.confirm_yes'])}
                                </Button>
                            </Layout>
                            <Layout
                                grow={0}
                                justify="center"
                            >
                                <Link
                                    isMuted
                                    onClick={this.onCredentialDeleteCancel.bind(this)}
                                >
                                    {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.confirm_no'])}
                                </Link>
                            </Layout>
                        </ModalContent>
                    </Modal>
                }

            </LoginPreferencesCardWrapper>
        );
    }
}

module.exports = injectIntl(TwoFaViaFingerprintPopUp);